import { useEffect } from "react";
import useAudioAdapter from "@/common/hooks/useAudioAdapter.ts";
import { useQueryState } from "nuqs";
import { URLSearchParamKeys } from "@/enum/URLSearchParamKeys.ts";

function useSetCurrentTimeFromUrlSearchParam() {
  const [audioAdapter] = useAudioAdapter();
  const [timeParam] = useQueryState(URLSearchParamKeys.AUDIO_CURRENT_TIME, { shallow: true });

  useEffect(() => {
    if (timeParam) {
      audioAdapter?.setCurrentTime(+timeParam);
    }
  }, [
    audioAdapter,
    timeParam
  ]);
}

export default useSetCurrentTimeFromUrlSearchParam;
